import { ModalBody, ModalFooter } from 'ui/modal';

import { EntityTypeInput } from './EntityTypeInput';
import { ImportTypeInput } from './ImportTypeInput';
import { ReviewChangesButton } from './ReviewChangesButton';
import { useHandleSubmit } from './hooks/useHandleSubmit';
import { FORM_ID } from './constants';
import { useValidationErrorToast } from './hooks/useValidationErrorToast';
import { SubmitSuccessHandlerFn } from './types';
import { ChangeCommentInput } from './ChangeCommentInput';

type SetupStepFormProps = {
  onSubmit: SubmitSuccessHandlerFn;
  onClose: () => void;
};

export const SetupStepForm = ({ onSubmit, onClose }: SetupStepFormProps) => {
  const handleSubmit = useHandleSubmit(onSubmit);
  useValidationErrorToast();

  return (
    <>
      <ModalBody>
        <form id={FORM_ID} onSubmit={handleSubmit} data-test="setup-step">
          <EntityTypeInput />
          <ImportTypeInput />
          <ChangeCommentInput />
        </form>
      </ModalBody>
      <ModalFooter onClose={onClose}>
        <ReviewChangesButton />
      </ModalFooter>
    </>
  );
};
